'use client';

import { useId } from 'react';

import { useIsClient } from 'usehooks-ts';

import { useAuth } from '@shared/common/providers/AuthProvider';

import { ADS_CONSTANTS } from '../AdsConstants';
import { useAppendScript, useUserAdSettings } from '../hooks';
import styles from './StoreAppInlineTopBannerTextButton.module.scss';

interface StoreAppInlineTopBannerTextButtonProps {
  dataKey: string;
}

export const StoreAppInlineTopBannerTextButton = ({
  dataKey,
}: StoreAppInlineTopBannerTextButtonProps) => {
  const { showStoreAppInlineTopBannerTextButton } = useUserAdSettings();

  const { user } = useAuth();
  const id = useId();
  const userId = user?.id;

  const isClient = useIsClient();

  useAppendScript({
    id,
    userId,
  });

  if (!showStoreAppInlineTopBannerTextButton) {
    return null;
  }

  return (
    <div className={styles.container}>
      {!isClient ? (
        <div className={styles.placeholder} />
      ) : (
        <div id={id}>
          <ins className={ADS_CONSTANTS.className} data-cp-user-id={userId} data-key={dataKey} />
        </div>
      )}
    </div>
  );
};
